import React, { useEffect, useRef, useState } from "react";

const SystemCapabilitiesSection = ({ capabilities }) => {
  const sectionRef = useRef();
  const [visibleIndexes, setVisibleIndexes] = useState([]);

  useEffect(() => {
    const cards = sectionRef.current.querySelectorAll(".capability-card");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.getAttribute("data-index"), 10);
            setVisibleIndexes((prev) => [...new Set([...prev, index])]);
          }
        });
      },
      { threshold: 0.3 }
    );

    cards.forEach((card) => observer.observe(card));
    return () => observer.disconnect();
  }, []);

  const getCardClass = (index) => {
    const baseClass = [0, 2, 5, 7].includes(index)
      ? "capability-card green"
      : "capability-card white";
    return visibleIndexes.includes(index)
      ? `${baseClass} zoom-in`
      : baseClass;
  };

  return (
    <section className="system-capabilities-section py-5" ref={sectionRef}>
      <div className="container">
        <h2 className="text-center fw-bold mb-4 text-dark">
          System Capabilities
        </h2>
        <div className="row">
          {capabilities.map((item, i) => (
            <div className="col-12 col-sm-6 col-lg-3 mb-4" key={i}>
              <div className={getCardClass(i)} data-index={i}>
                <i className={`bi ${item.icon} capability-icon`}></i>
                <h5 className="capability-title">{item.title}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SystemCapabilitiesSection;
